import { submitEvent } from '@otto-ec/tracking-bct';
import { getProductFeaturesForNonPdpPage } from '../../../_common/client/tracking/get-product-features-for-non-pdp-page';
import { ReviewSource } from '../../../_common/types/customer-review/review-submission-data';

export type SubmitServerActionParams = {
    variationId: string;
    success: boolean;
    source: ReviewSource;
    daysSinceOrder: number | undefined;

    stars: number;
    textLength: number;
    recommendation: boolean | undefined;
    productFitValue: number | undefined;
    productQualityValue: number | undefined;
    productDesignValue: number | undefined;
    assemblyValue: number | undefined;
    comfortValue: number | undefined;
    valueForMoneyValue: number | undefined;
    imagesCount: number;
};
export const emitSubmitServerActionTracking = ({
    recommendation,
    stars,
    textLength,
    source,
    productFitValue,
    productQualityValue,
    productDesignValue,
    assemblyValue,
    comfortValue,
    valueForMoneyValue,
    daysSinceOrder,
    success,
    variationId,
    imagesCount,
}: SubmitServerActionParams) => {
    submitEvent(
        {
            ot_PageCluster: ['Kundenbewertungsformular'],
            review_CustomerReviewWrite: ['send'],
            review_CustomerReviewSuccess: [success ? 'true' : 'false'],
            review_Source: [source],
            ...(daysSinceOrder ? { review_DaysSinceOrder: [daysSinceOrder.toString()] } : {}),

            review_CustomerReviewStars: [stars.toString()],
            review_CustomerReviewTextLength: [textLength.toString()],
            review_ImageCount: [imagesCount.toString()],
            ...(recommendation ? { review_CustomerReviewRecommendation: [recommendation ? 'true' : 'false'] } : {}),
            ...(productFitValue !== undefined ? { review_ProductFitValue: [productFitValue.toString()] } : {}),
            ...(productQualityValue !== undefined ? { review_ProductQualityValue: [productQualityValue.toString()] } : {}),
            ...(productDesignValue !== undefined ? { review_ProductDesignValue: [productDesignValue.toString()] } : {}),
            ...(assemblyValue !== undefined ? { review_AssemblyValue: [assemblyValue.toString()] } : {}),
            ...(comfortValue !== undefined ? { review_ComfortValue: [comfortValue.toString()] } : {}),
            ...(valueForMoneyValue !== undefined ? { review_ValueForMoneyValue: [valueForMoneyValue.toString()] } : {}),
        },
        {
            name: 'click',
            features: getProductFeaturesForNonPdpPage(variationId),
        }
    );
};

export type TrackFormErrorActionParams = {
    variationId: string;
    source: ReviewSource;
    errorReason: string;
};
export const emitFormErrorActionTracking = ({ source, errorReason, variationId }: TrackFormErrorActionParams) => {
    submitEvent(
        {
            review_CustomerReviewWrite: ['error'],
            review_ErrorUserCustomerReview: [errorReason],
            review_Source: [source],
        },
        {
            name: 'click',
            features: getProductFeaturesForNonPdpPage(variationId),
        }
    );
};
